enum FIELDS_COMPONENTS {
  AMOUNT_UNIT = 'AMOUNT_UNIT',
  ANIMAL_BIRTHDAY = 'ANIMAL_BIRTHDAY',
  ANIMAL_NAME = 'ANIMAL_NAME',
  ANIMAL_TEMPLATE = 'ANIMAL_TEMPLATE',
  BOOSTER = 'BOOSTER',
  BUTTON_CHECKBOX = 'BUTTON_CHECKBOX',
  CARD_READER = 'CARD_READER',
  CASH_PAYMENT = 'CASH_PAYMENT',
  CHECKBOX = 'CHECKBOX',
  CHECK_NUMBER = 'CHECK_NUMBER',
  COLOR_SELECTOR = 'COLOR_SELECTOR',
  CONTACT = 'CONTACT',
  CONTACT_TYPE = 'CONTACT_TYPE',
  COST_UNIT = 'COST_UNIT',
  COUNTRY = 'COUNTRY',
  DATE = 'DATE',
  DATE_PICKER = 'DATE_PICKER',
  DROPDOWN = 'DROPDOWN',
  DONATION_AMOUNT = 'DONATION_AMOUNT',
  EDITOR = 'EDITOR',
  EMAIL = 'EMAIL',
  FIELD_STRING = 'FIELD_STRING',
  FILE = 'FILE',
  FREQUENCY = 'FREQUENCY',
  GMAP = 'GMAP',
  GROUP = 'GROUP',
  HEADER = 'HEADER',
  HEX_COLOR = 'HEX_COLOR',
  HOLD_STATUS = 'HOLD_STATUS',
  IMAGE_UPLOAD = 'IMAGE_UPLOAD',
  INTAKE_WAIVERS = 'INTAKE_WAIVERS',
  KENNEL_MANAGER = 'KENNEL_MANAGER',
  LINK = 'LINK',
  LIST = 'LIST',
  LOCATION = 'LOCATION',
  MICROCHIP = 'MICROCHIP',
  MICROCHIP_ISSUER = 'MICROCHIP_ISSUER',
  MONEY = 'MONEY',
  MULTISELECT = 'MULTISELECT',
  NUMBER = 'NUMBER',
  PARAGRAPH = 'PARAGRAPH',
  PASSWORD = 'PASSWORD',
  PHONE_CARD = 'PHONE_CARD',
  PROFILE_INFO = 'PROFILE_INFO',
  OPEN_MODAL = 'OPEN_MODAL',
  OUTCOME_VOUCHERS = 'OUTCOME_VOUCHERS',
  PRINT = 'PRINT',
  RADIO = 'RADIO',
  RESULT = 'RESULT',
  CUSTOM_ADDITIONAL_FEE = 'CUSTOM_ADDITIONAL_FEE',
  SEPARATOR = 'SEPARATOR',
  SUBHEADER = 'SUBHEADER',
  SPECIES = 'SPECIES',
  SPLIT_PAYMENT = 'SPLIT_PAYMENT',
  STAFF = 'STAFF',
  STRIPE = 'STRIPE',
  TAG = 'TAG',
  TEL = 'TEL',
  TEXT = 'TEXT',
  TEXTAREA = 'TEXTAREA',
  TIMEFRAME = 'TIMEFRAME',
  TOGGLE = 'TOGGLE',
  WEIGHT = 'WEIGHT',
}

enum FORM_VALIDATIONS {
  MAX_LENGTH = 'MAX_LENGHT',
  MIN_LENGTH = 'MIN_LENGHT',
}

/**
 * NOTE: Settings that turn a date field into a date+time one. Spread it into a field's `settings`.
 *
 * All three keys are load-bearing: `type` picks the date+time payload converter, `showTime` gives
 * the picker its clock, and `withTime` makes the read-only render show the time. Set only
 * `showTime` and the user picks a time the payload then throws away — with no error.
 */
const DATE_TIME_FIELD_SETTINGS = {
  showTime: true,
  type: 'date_iso_string',
  withTime: true,
};

export { DATE_TIME_FIELD_SETTINGS, FIELDS_COMPONENTS, FORM_VALIDATIONS };
